import React from 'react';
import UnderConstructionScreen from './UnderConstructionScreen';

const HostResponsibilitiesScreen = () => (
    <UnderConstructionScreen
        eyebrow="Host Responsibilities"
        icon="shield-account-outline"
        title="What it means to be a SnapCamp host."
        subtitle="We are documenting the standards, expectations, and commitments that all SnapCamp hosts agree to — ensuring every family on the platform can trust the programs they find."
        accentColor="#0EA5E9"
        features={[
            {
                icon: 'clipboard-check-outline',
                title: 'Platform standards',
                description: 'Clear guidelines covering camp legitimacy, documentation, communication, and safety expectations for all listed programs.',
            },
            {
                icon: 'account-badge-outline',
                title: 'Host verification process',
                description: 'An overview of how SnapCamp reviews and verifies camp operators before they go live on the platform.',
            },
            {
                icon: 'hand-heart-outline',
                title: 'Family trust commitments',
                description: 'The promises hosts make to families: accurate listings, timely responses, and maintaining a safe and welcoming program environment.',
            },
        ]}
        contactPrompt="Questions about hosting standards?"
        contactEmail="hosting@snapcamp.ai"
    />
);

export default HostResponsibilitiesScreen;
